<template>
  <div v-if="data.length!={}" id="brands" class="container">
    <div class="t">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>品牌列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="t2" v-bind:style="{backgroundImage:'url('+ serve + banner + ')'}"></div>
    <div>
      <el-row :gutter="40">
        <el-col :span="6" v-for="(item,index) of results" :key="index">
          <div class="item">
            <div>
              <img :src="serve+item.logo" style="width: 268px; height: 150px" alt />
            </div>
            <div class="l1">
              <router-link :to="'/viewBrands?id='+item.id" class="lv1Text">{{item.name}}</router-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div align="center" class="pager">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="data.total"
        :page-size="16"
        @current-change="pageChange"
        hide-on-single-page
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: 1,
      data: [],
      banner: "",
      results: {}
    };
  },
  created() {
    //
    this.initData();
  },
  methods: {
    pageChange(v) {
      this.page = v;
      this.load();
    },
    load() {
      this.axios
        .get(this.serve + "/get_brand_list", {
          params: {
            mobile: this.mobile,
            token: this.token,
            page: this.page
          }
        })
        .then(res => {
          this.data = res.data;
          this.results = res.data.results;
        });
    },
    initData() {
      this.axios.get(this.serve + "/get_banner?type=brand").then(res => {
        this.banner = res.data.data.image;
      });
      this.axios
        .get(this.serve + "/get_brand_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1
          }
        })
        .then(res => {
          this.data = res.data;
          this.results = res.data.results;
        });
    }
  }
};
</script>
<style lang="scss">
#brands {
  .pager {
    background-color: transparent;
  }
  .l1:hover {
    text-decoration: underline;
  }
  .item {
    background-color: #fff;
    border: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .t {
    padding: 15px 0;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    width: 1200px;
    margin: 0 auto;
  }
  .t2 {
    height: 200px;
    margin: 0 0 30px 0;
  }
  .t3 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .l1 {
    text-align: center;
    line-height: 3em;
  }
}
</style>